import React from 'react';
import './GuideDetail.css';
import { useNavigate } from 'react-router-dom';

function GuideDetail({ section }) {
  const navigate = useNavigate();

  const handleConceptClick = (detailKey) => {
    navigate(`/console/guides/${detailKey}`);
  };

  return (
    <div className="guide-detail">
      <ul className="guide-detail-list">
        {section.items && section.items.map((item, index) => (
          <li key={index} className="guide-detail-item">{item}</li>
        ))}

        {section.coreConcepts && section.coreConcepts.map((concept, index) => (
          <li
            key={index}
            className="guide-detail-item guide-detail-clickable"
            onClick={() => handleConceptClick(concept.detailKey)}
          >
            {concept.title}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default GuideDetail;
